export default __webpack_public_path__ + "images/SC.4802abb.png";